/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AffiliatePaymentDetailDto,
    AffiliatePaymentDetailDtoFromJSON,
    AffiliatePaymentDetailDtoFromJSONTyped,
    AffiliatePaymentDetailDtoToJSON,
} from './AffiliatePaymentDetailDto';

/**
 * 
 * @export
 * @interface AffiliatePaymentDetailPaginatedDto
 */
export interface AffiliatePaymentDetailPaginatedDto {
    /**
     * 
     * @type {Array<AffiliatePaymentDetailDto>}
     * @memberof AffiliatePaymentDetailPaginatedDto
     */
    items: Array<AffiliatePaymentDetailDto>;
    /**
     * 
     * @type {number}
     * @memberof AffiliatePaymentDetailPaginatedDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof AffiliatePaymentDetailPaginatedDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof AffiliatePaymentDetailPaginatedDto
     */
    offset: number;
}

export function AffiliatePaymentDetailPaginatedDtoFromJSON(json: any): AffiliatePaymentDetailPaginatedDto {
    return AffiliatePaymentDetailPaginatedDtoFromJSONTyped(json, false);
}

export function AffiliatePaymentDetailPaginatedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliatePaymentDetailPaginatedDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AffiliatePaymentDetailDtoFromJSON)),
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function AffiliatePaymentDetailPaginatedDtoToJSON(value?: AffiliatePaymentDetailPaginatedDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(AffiliatePaymentDetailDtoToJSON)),
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
    };
}

